import { combineReducers } from "redux";
import GlobalReducer from "./globalReducer";
import HomeReducer from "./homeReducer";
import SnackBarReducer from "./snackBarReducer";
import studentReducer from "./studentReducer";
import reportReducer from "./reportReducer";
import authReducer from "./auth";
import externalFeePaymentReducer from "./externalFeePaymentReducer";

export default combineReducers({
  global: GlobalReducer,
  home: HomeReducer,
  snackBar: SnackBarReducer,
  student: studentReducer,
  report: reportReducer,
  auth: authReducer,
  externalFeePayment: externalFeePaymentReducer,
});
